<template>
  <div class="preview d-flex flex-column justify-center">
    <div class="header d-flex justify-space-between align-end mb-2">
      <div class="d-flex align-center">
        <HeaderCharacterIcon :id="id" :character="name" />
        <div>
          <h2 class="text-h5">{{ name }}</h2>
          <small class="text-caption">{{ count }} images</small>
        </div>
      </div>
      <v-btn small :to="{ name: 'Character', params: { id } }">
        View more
      </v-btn>
    </div>
    <v-sheet
      color="white"
      elevation="1"
    >
      <div v-if="count > 2" class="gallery d-flex justify-center">
        <div class="left d-flex flex-column justify-center">
          <router-link class="image" :to="{ name: 'Image', params: { name: images[0] } }" :style="{ backgroundImage: `url(${apiUrl}/thumb/${images[0]})` }"></router-link>
          <router-link class="image" :to="{ name: 'Image', params: { name: images[1] } }" :style="{ backgroundImage: `url(${apiUrl}/thumb/${images[1]})` }"></router-link>
        </div>
        <router-link v-if="more" :to="{ name: 'Character', params: { id } }" class="right">
          <div class="image" :style="{ backgroundImage: `url(${apiUrl}/thumb/${images[2]})` }"></div>
          <v-overlay absolute>+{{ countMore }}</v-overlay>
        </router-link>
        <div v-else class="right">
          <router-link class="image" :to="{ name: 'Image', params: { name: images[2] } }" :style="{ backgroundImage: `url(${apiUrl}/thumb/${images[2]})` }"></router-link>
        </div>
      </div>
      <div v-else-if="count > 1" class="gallery d-flex justify-center">
        <div class="right">
          <router-link class="image" :to="{ name: 'Image', params: { name: images[0] } }" :style="{ backgroundImage: `url(${apiUrl}/thumb/${images[0]})` }"></router-link>
        </div>
        <div class="right">
          <router-link class="image" :to="{ name: 'Image', params: { name: images[1] } }" :style="{ backgroundImage: `url(${apiUrl}/thumb/${images[1]})` }"></router-link>
        </div>
      </div>
      <div v-else-if="count" class="gallery d-flex justify-center">
        <router-link class="image" :to="{ name: 'Image', params: { name: images[0] } }" :style="{ backgroundImage: `url(${apiUrl}/thumb/${images[0]})` }"></router-link>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import HeaderCharacterIcon from './HeaderCharacterIcon'

export default {
  components: {
    HeaderCharacterIcon
  },
  props: {
    id: String, 
    name: String,
    count: Number,
    images: Array
  },
  data: () => ({
    apiUrl: process.env.VUE_APP_API_URL
  }),
  computed: {
    more () {
      return this.count > 3
    },
    countMore () {
      return this.count - 2
    }
  }
}
</script>

<style scoped>
.preview {
  width: 300px;
}

.image {
  display: block;
  height: 150px;
  width: 300px;
  background-size: cover;
  background-position: center;
}

.left .image {
  height: 75px;
  width: 150px;
}

.left + .right {
  position: relative;
}

.right .image {
  height: 150px;
  width: 150px;
}
</style>
